import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { DreamType } from "source/app/presentation/MainPanel/Dreams/DreamEditor/DreamType";
import { LaunchDreamEditor } from "source/app/presentation/MainPanel/Dreams/DreamEditor/Launch/Launch";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "../../../../../services/UI/State/State";
import { IsBoardsFilterActive } from "../../DreamFilterButtons/Filters/Boards/ShowBoards";
import { GetEnergyHashTagsSearchText } from "../../Exclusion/GetEnergyHashTagsSearchText";

export function HandleNewDreamEditorLaunch(
    dreamAttribute: EDA | undefined,
    dreamsState: IDreamsState
) {
    if (dreamAttribute) {
        LaunchDreamEditor(DreamType.New, {}, dreamsState.sortedData, {
            emotion: ">",
            attributes: GetExtendedAttributes([EDA[dreamAttribute]]),
        });
    } else {
        const energyHashTagsSearchText = GetEnergyHashTagsSearchText();

        const name =
            dreamsState.searchText === energyHashTagsSearchText
                ? ``
                : dreamsState.searchText + ` `;

        LaunchDreamEditor(DreamType.New, {}, dreamsState.sortedData, {
            name,
            isresonating: dreamsState.onlyShowTodaysDreams,
        });
    }
}

function GetExtendedAttributes(existingAttributes: string[]) {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (IsBoardsFilterActive(dreams.state)) {
        return [...existingAttributes, EDA[EDA.board]];
    } else {
        return existingAttributes;
    }
}
